





















import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ThemeSwitcher",
})
export default class ThemeSwitcher extends Vue {
  animating = false;

  get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  get currentIcon(): string {
    return this.isDark ? "mdi-weather-night" : "mdi-weather-sunny";
  }

  get tooltipText(): string {
    return this.isDark ? "Cambiar a tema claro" : "Cambiar a tema oscuro";
  }

  mounted(): void {
    // Cargar preferencia guardada
    const savedTheme = localStorage.getItem("darkTheme");
    if (savedTheme !== null) {
      this.$vuetify.theme.dark = savedTheme === "true";
    }
  }

  toggleTheme(): void {
    this.animating = true;

    setTimeout(() => {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("darkTheme", String(this.$vuetify.theme.dark));
      this.$emit("theme-changed", this.$vuetify.theme.dark);

      setTimeout(() => {
        this.animating = false;
      }, 300);
    }, 150);
  }
}
